import { useTheme } from '@emotion/react'
import { Container, Grid } from '@mui/material'
import React from 'react'
import { SectionHeading, SectionWrapper } from '../../../Styles/style'
import ContCards from './Components/ContCards'
import alan from "../../../../assets/images/alan.png"
import ole from "../../../../assets/images/ole.png"
import dim from "../../../../assets/images/dim.png"
import liam from "../../../../assets/images/liam.png"
import json from "../../../../assets/images/json.png"
import amur from "../../../../assets/images/amur.png"
import Availible from "../../../Components/Availible"
import S9_Footer from "../../Main/S9_Footer"
import styled from '@emotion/styled'

const ContriGrid = styled(Grid)`

text-align: -webkit-center;
text-align: -moz-center;
`
const S2_Contributors = () => {
    const theme = useTheme()
    return (
        <div>
            <SectionWrapper bgcolor={theme.bgSecondary} p="4rem 0">
                <Container maxWidth="xl" >
                    <SectionHeading p="60px 0" align="center" color={theme.textSecondary} data-aos="fade-zoom-in"
                        data-aos-easing="ease-in"
                        data-aos-delay="300"
                        data-aos-offset="0"
                        data-aos-duration="500">Contributors</SectionHeading>
                    <ContriGrid container spacing={3} >
                        <Grid item xs={12} md={4} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom"
                            data-aos-delay="300"
                            data-aos-offset="0"
                            data-aos-duration="1000"><ContCards img={alan} desig="FOUNDER/OPERATIONS LEAD" name="Alan Scott Jr." linkedinlink="#" /></Grid>
                        <Grid item xs={12} md={4} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom"
                            data-aos-delay="400"
                            data-aos-offset="0"
                            data-aos-duration="1000"><ContCards img={ole} desig="CTO/CO-FOUNDER" name="Oleksandra" linkedinlink="#" /></Grid>
                        <Grid item xs={12} md={4} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom"
                            data-aos-delay="500"
                            data-aos-offset="0"
                            data-aos-duration="1000"><ContCards img={dim} desig="HEAD OF ENGINEERING" name="Dimitry" linkedinlink="#" /></Grid>
                        <Grid item xs={12} md={4} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom"
                            data-aos-delay="300"
                            data-aos-offset="0"
                            data-aos-duration="1000"><ContCards img={liam} desig="DEFI PRODUCT DESIGNER" name="Liam" linkedinlink="#" /></Grid>
                        <Grid item xs={12} md={4} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom"
                            data-aos-delay="400"
                            data-aos-offset="0"
                            data-aos-duration="1000"><ContCards img={json} desig="FRONT END TEAM LEAD" name="Jason" linkedinlink="#" /></Grid>
                        <Grid item xs={12} md={4} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom"
                            data-aos-delay="500"
                            data-aos-offset="0"
                            data-aos-duration="1000"><ContCards img={amur} desig="SENIOR FULL STACK ENGINEER" name="Amur" linkedinlink="#" /></Grid>
                    </ContriGrid>

                </Container>
            </SectionWrapper>
            <Availible />
            <S9_Footer />
        </div>
    )
}

export default S2_Contributors